import DqSettingspanel from './src/settingspanel'

/* istanbul ignore next */
DqSettingspanel.install = function (Vue) {
  Vue.component(DqSettingspanel.name, DqSettingspanel)
}

export default DqSettingspanel



// WEBPACK FOOTER //
// ./src/dq-ui/packages/settingspanel/settingspanel.js